<template>
  <div class="row justify-content-center">
    <div class="col-md-5">
      <h3 class="text-center" style="margin-bottom: 30px;">Aggiorna DOG</h3>
      <b-form @submit.prevent="onFormSubmit">
        <div>
          <b-input-group prepend="Nome Cane" size="7" class="mb-4">
            <b-form-input aria-label="name" class="ml-3" v-model="dog.name" placeholder="" :formatter="formatter" required></b-form-input>
          </b-input-group>
          <b-input-group prepend="Razza" size="7" class="mb-4">
            <template v-if="dog.breedName!=''">
              <b-form-input aria-label="breedName" class="ml-3" v-model="dog.breedName" placeholder="" required></b-form-input>
            </template>
            <template v-else>
              <v-select label="breedName" v-model="selectedBreed" class="ml-3" style="width: 198px; height: 20px;" :value="$store.myValue" :options="options" :reduce="breedName => breedName.selBreed" @input="feedBreed" placeholder="Seleziona--" required>
              </v-select>
            </template>
          </b-input-group>
        </div>
        <div>
          <b-input-group prepend="Taglia / tipo di pelo" class="mb-4">
            <b-form-select aria-label="size" class="mx-3" style="max-width: 25%" v-model="dog.size" :options="sizeOptions" placeholder="Tg" required>
              <option v-for="(text, value) in sizeOptions" 
                :key="value"
                :value="text">
              </option>
            </b-form-select>
            <span style="vertical-align: middle">/</span>
            <b-form-select aria-label="hair" class="ml-3" style="max-width: 25%" v-model="dog.hair" :options="hairOptions" placeholder="pelo" required>
              <option v-for="(text, value) in hairOptions" 
                :key="value"
                :value="text">
              </option>
            </b-form-select>
          </b-input-group>
        </div>
        <div>
          <b-input-group prepend="Gruppo SELF" class="mb-4">
            <b-form-select aria-label="washpgm" class="mx-3" style="max-width: 25%" v-model="dog.washPgm" :options="washPgmOptions" placeholder="wash Pgm" required>
              <option v-for="(text, value) in washPgmOptions" 
                :key="value"
                :value="text">
              </option>
            </b-form-select>
            <b-form-radio-group
              v-model="dog.sex"
              :options="sexOptions"
              button-variant="outline-success"
              name="radio-btn-outline"
              buttons
              >
            </b-form-radio-group>
          </b-input-group>
        </div>
        <div>
          <b-input-group prepend="Nato/a il" size="7" class="mb-4">
            <b-form-datepicker aria-label="birthday" class="ml-3" v-model="dog.birthday" placeholder="" required></b-form-datepicker>
          </b-input-group>
        </div>
        <div>
          <b-input-group size="7" class="mb-4">
            <b-form-input aria-label="notes" type="text" v-model="dog.notes[0].note" placeholder="note"></b-form-input>
          </b-input-group>
        </div>
        <p class="error">{{ error.message }}</p>
        <div class="form-group">
          <button class="btn btn-primary btn-block">SALVA</button>
        </div>
        <p class="success">{{ success.message }}</p>
      </b-form>

      <b-modal ref="my-modal" centered hide-footer title="Cane AGGIORNATO">
        <div class="d-block text-center">
          <h3>Cane <strong>{{ dog.name }}</strong> di {{ sel_user.data.displayName }} aggiornato.
          </h3>
        </div>
        <b-button class="mt-2" variant="outline-success" block @click="hideModal">
          CHIUDI
        </b-button>
      </b-modal>
    </div>
  </div>
</template>

<script>
  import { db } from '../../firebase/config.js';
  import { mapGetters, mapMutations } from 'vuex';

  export default {
    data() {
      return {
        selectedBreed: {},
        options: [],
        dog: {
          name: '',
          breedRef: '',
          breedName: '',
          size: 0,
          hair: 0,
          washPgm: '',
          birthday: '',
          sex: '',
          alive: true,
          notes: [{
            note: null,
            date: null,
          }],
        },
        sizeOptions: [
          { text: 'XS', value: 1 },
          { text: 'S', value: 2 },
          { text: 'M', value: 3 },
          { text: 'L', value: 4 },
          { text: 'XL', value: 5 },
          { text: 'XXL', value: 6 },
        ],
        hairOptions: [
          { text: 'S', value: 1 },
          { text: 'M', value: 2 },
          { text: 'L', value: 3 }
        ],
        washPgmOptions: [
          { text: 'XS/S', value: '11' },
          { text: 'XS/M', value: '12' },
          { text: 'XS/L', value: '13' },
          { text: 'S/S', value: '21' },
          { text: 'S/M', value: '22' },
          { text: 'S/L', value: '23' },
          { text: 'M/S', value: '31' },
          { text: 'M/M', value: '32' },
          { text: 'M/L', value: '33' },
          { text: 'L/S', value: '41' },
          { text: 'L/M', value: '42' },
          { text: 'L/L', value: '43' },
          { text: 'XL/S', value: '51' },
          { text: 'XL/M', value: '52' },
          { text: 'XL/L', value: '53' },
          { text: 'XXL/S', value: '61' },
          { text: 'XXL/M', value: '62' },
          { text: 'XXL/L', value: '63' },
        ],
        sexOptions: [
          { text: 'Maschio', value: 'M' },
          { text: 'Femmina', value: 'F' }
        ],
        /*selectedStatus: true,
        statusOptions: [
           { text: 'vivo', value: true },
           { text: 'morto', value: false }
        ],*/
        error: {
          value: null,
          message: ''
        },
        success: {
          value: null,
          message: ''
        }
      }
    },
    created() {
      const dogRef = db.collection('users').doc(this.sel_user.data.id).
      collection('dogs').doc(this.sel_dog.id)
      console.log('dogRef ->', dogRef.path);
      db.doc(dogRef.path).get().then((doc) => {
        this.dog = doc.data();
      }).catch((error) => {
        console.log(error)
      });
      this.selectedBreed = {
        breedName: this.dog.breedName,
        selBreed: {
          id: this.dog.breedRef,
          data: {
            name: this.dog.breedName,
            size: this.dog.size,
            hair: this.dog.hair,
            washPgm: parseInt(this.dog.washPgm)
          }
        }
      };
    },
    mounted() {
      this.options = []
      db.collection('breeds').get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          this.options.push({
            breedName: doc.data().name,
            selBreed: {
              id: doc.id,
              data: doc.data(),
            }
          });
        });
        console.log("options => ", this.options);
      })
      .catch((error) => {
        console.log("Error getting documents: ", error);
      })
    },
    methods: {  
      formatter(value) {
        return value.toUpperCase()
      },
      showModal() {
        this.$refs['my-modal'].show()
      },
      hideModal() {
        console.log('aggiornamento USER')
        this.$refs['my-modal'].hide()
        this.$router.push({name:'user_detail'})
      },
      feedBreed(value) {
        event.preventDefault();
        console.log("selectedBreedData -> ", value);
        console.log(event.target.value);
        this.dog.breedRef = value.id;
        this.dog.breedName = value.data.name;
        this.dog.size = value.data.size;
        this.dog.hair = value.data.hair;
        this.dog.washPgm = value.data.washPgm.toString();
      },   
      onFormSubmit(event) {
        event.preventDefault();
        if(this.dog.notes[0].note !== null) {
          this.dog.notes[0].date = new Date().toLocaleString()
        }
        const userRef = db.collection('users').doc(this.sel_user.data.id);
        console.log('userRef ->', userRef.path);
        db.doc(userRef.path).collection('dogs').doc(this.sel_dog.id)
        .update(this.dog)
        .then(() => {
          console.log("DOG aggiornato!");
          this.showModal();
        })
        .catch((error) => {
          console.log(error.message, error)
          this.showModal();
        });
      },
      ...mapMutations({
        set_sel_dog: 'SET_SEL_DOG', // map `this.set_sel_dog()` to `this.$store.commit('SET_SEL_DOG')`
      }),
    },
    computed: {
      ...mapGetters({
        // map `this.sel_user` to `this.$store.getters._user`
        sel_user: "_user",
        sel_dog: "_dog",
      }),
    },
  };
</script>

<style>
  .btn-primary {
    background: #bad300;
    border: #bad000;
  }
  .material-icons {
    font-size: 24px;
    margin-right: 10px;
    color: #ccc;
    cursor: pointer;
  }
  .material-icons:hover {
    color: #777;
  }
  .success {
    color: $success;
  }
</style>